import {ReportData} from "../../../reports/report.data";
import {collection, field} from "@fedeltapointofsale/data-client";
import {AccountReportSelectionControlData} from "../../account/controls/account-report-selection-control.component";
import {MembershipTypeReportSelectionData} from "../../../customers/membership-type/controls/membership-type-report-selection-control.component";

export class AccountSummaryReportData extends ReportData<AccountSummaryReportData> {
    @field summary: boolean = true;
    @collection(AccountReportSelectionControlData) accounts: AccountReportSelectionControlData[];
    @collection(MembershipTypeReportSelectionData) membershipType: MembershipTypeReportSelectionData[];
}
